import { combineReducers } from 'redux';
import appReducer from './appReducer';
import topicListReducer from './topicListReducer';
import touchPadReducer from "./touchPadReducer";
import topicHeaderReducer from './topicHeaderReducer';

export default combineReducers({
    appReducer,
    topicListReducer,
    touchPadReducer,
    topicHeaderReducer,
});
